import { useCallback, useEffect, useMemo, useState } from 'react';
import { fetchLeaderboard } from '../api/leaderboardApi';

export function useLeaderboard(params = {}, options = {}) {
  const enabled = options.enabled !== false;
  const paramsKey = useMemo(
    () => JSON.stringify({
      board: params.board || 'xp',
      scope: params.scope || 'global',
      period: params.period || 'all',
      report_status: params.report_status || 'valid',
      view: params.view || 'top',
      city: params.city || '',
      crew_id: params.crew_id ?? null,
      limit: params.limit ?? null,
      offset: params.offset ?? null,
    }),
    [params.board, params.scope, params.period, params.report_status, params.view, params.city, params.crew_id, params.limit, params.offset]
  );
  const stableParams = useMemo(() => JSON.parse(paramsKey), [paramsKey]);

  const [data, setData] = useState({
    items: [],
    total_ranked_users: 0,
    my_rank: null,
    my_entry: null,
    board: stableParams.board || 'xp',
    scope: stableParams.scope || 'global',
    period: stableParams.period || 'all',
    report_status: stableParams.report_status || 'valid',
    view: stableParams.view || 'top',
    city: stableParams.city || '',
    cities: [],
    summary: null,
    estimate_note: '',
    estimate_values: null,
  });
  const [loading, setLoading] = useState(Boolean(enabled));
  const [error, setError] = useState(null);

  const reload = useCallback(async () => {
    if (!enabled) {
      setLoading(false);
      setError(null);
      setData(prev => ({
        ...prev,
        items: [],
        total_ranked_users: 0,
        my_rank: null,
        my_entry: null,
        board: stableParams.board || 'xp',
        scope: stableParams.scope || 'global',
        period: stableParams.period || 'all',
        report_status: stableParams.report_status || 'valid',
        view: stableParams.view || 'top',
        city: stableParams.city || '',
        cities: [],
        summary: null,
        estimate_note: '',
        estimate_values: null,
      }));
      return null;
    }

    setLoading(true);
    setError(null);

    try {
      const nextData = await fetchLeaderboard(stableParams);
      setData(nextData);
      return nextData;
    } catch (loadError) {
      setError(loadError);
      return null;
    } finally {
      setLoading(false);
    }
  }, [enabled, stableParams]);

  useEffect(() => {
    reload();
  }, [reload]);

  return {
    ...data,
    loading,
    error,
    reload,
  };
}

export default useLeaderboard;
